module.exports = __webpack_public_path__ + "images/data_5.png";